import { render, staticRenderFns } from "./property-form-general.vue?vue&type=template&id=1d6e78d0&"
import script from "./property-form-general.vue?vue&type=script&lang=js&"
export * from "./property-form-general.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports